import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _16f85719 = () => interopDefault(import('../src/app/ui/TheAsideImage' /* webpackChunkName: "@/app/ui/TheAsideImage" */))
const _05bb4a70 = () => interopDefault(import('../src/pages/account.vue' /* webpackChunkName: "" */))
const _49ec4b5e = () => interopDefault(import('../src/pages/account/change-password.vue' /* webpackChunkName: "pages/account/change-password" */))
const _57a42488 = () => interopDefault(import('../src/pages/account/email-confirm.vue' /* webpackChunkName: "pages/account/email-confirm" */))
const _5bea0da7 = () => interopDefault(import('../src/pages/account/email-confirmed.vue' /* webpackChunkName: "pages/account/email-confirmed" */))
const _41aa0484 = () => interopDefault(import('../src/pages/account/forgot-password.vue' /* webpackChunkName: "pages/account/forgot-password" */))
const _fc5155a8 = () => interopDefault(import('../src/pages/account/forgot-password-emailed.vue' /* webpackChunkName: "pages/account/forgot-password-emailed" */))
const _2373f160 = () => interopDefault(import('../src/pages/account/reglament.vue' /* webpackChunkName: "pages/account/reglament" */))
const _9d74b186 = () => interopDefault(import('../src/pages/account/set-password.vue' /* webpackChunkName: "pages/account/set-password" */))
const _39f56fdd = () => interopDefault(import('../src/pages/account/registration/agents.vue' /* webpackChunkName: "pages/account/registration/agents" */))
const _02f3c560 = () => interopDefault(import('../src/pages/account/registration/represes.vue' /* webpackChunkName: "pages/account/registration/represes" */))
const _25bf6844 = () => interopDefault(import('../src/pages/account/registration/steps/accepted.vue' /* webpackChunkName: "pages/account/registration/steps/accepted" */))
const _4ab4ddf7 = () => interopDefault(import('../src/pages/account/registration/steps/personal.vue' /* webpackChunkName: "pages/account/registration/steps/personal" */))
const _2c343fc0 = () => interopDefault(import('../src/pages/account/registration/steps/reglament.vue' /* webpackChunkName: "pages/account/registration/steps/reglament" */))
const _42301c99 = () => interopDefault(import('../src/pages/acts/index.vue' /* webpackChunkName: "pages/acts/index" */))
const _f158adf4 = () => interopDefault(import('../src/pages/agents/index.vue' /* webpackChunkName: "pages/agents/index" */))
const _f327f89e = () => interopDefault(import('../src/pages/agents/index/_id.vue' /* webpackChunkName: "pages/agents/index/_id" */))
const _ac6dfe4e = () => interopDefault(import('../src/pages/apartment-catalog.vue' /* webpackChunkName: "pages/apartment-catalog" */))
const _6b3e3214 = () => interopDefault(import('../src/pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _386e6cbe = () => interopDefault(import('../src/pages/calendar/index/_id.vue' /* webpackChunkName: "pages/calendar/index/_id" */))
const _10232f0a = () => interopDefault(import('../src/pages/choice-apartment.vue' /* webpackChunkName: "pages/choice-apartment" */))
const _58293284 = () => interopDefault(import('../src/pages/choice-apartment/index.vue' /* webpackChunkName: "pages/choice-apartment/index" */))
const _3984dd85 = () => interopDefault(import('../src/pages/choice-apartment/catalog.vue' /* webpackChunkName: "pages/choice-apartment/catalog" */))
const _71d8b2a6 = () => interopDefault(import('../src/pages/choice-apartment/chessboard/index.vue' /* webpackChunkName: "pages/choice-apartment/chessboard/index" */))
const _d617af3e = () => interopDefault(import('../src/pages/choice-apartment/strana-city.vue' /* webpackChunkName: "pages/choice-apartment/strana-city" */))
const _59ef984f = () => interopDefault(import('../src/pages/choice-apartment/chessboard/_project.vue' /* webpackChunkName: "pages/choice-apartment/chessboard/_project" */))
const _3df0dac4 = () => interopDefault(import('../src/pages/choice-apartment/_project.vue' /* webpackChunkName: "pages/choice-apartment/_project" */))
const _5fc0d166 = () => interopDefault(import('../src/pages/clients/index.vue' /* webpackChunkName: "pages/clients/index" */))
const _cd6407de = () => interopDefault(import('../src/pages/clients/index/_id.vue' /* webpackChunkName: "pages/clients/index/_id" */))
const _c6804040 = () => interopDefault(import('../src/pages/closed-sales.vue' /* webpackChunkName: "pages/closed-sales" */))
const _51c9eea0 = () => interopDefault(import('../src/pages/collections.vue' /* webpackChunkName: "pages/collections" */))
const _063365eb = () => interopDefault(import('../src/pages/collections/create.vue' /* webpackChunkName: "pages/collections/create" */))
const _3ac78364 = () => interopDefault(import('../src/pages/collections/manager.vue' /* webpackChunkName: "pages/collections/manager" */))
const _3cbddcbc = () => interopDefault(import('../src/pages/collections/manager/_id/index.vue' /* webpackChunkName: "pages/collections/manager/_id/index" */))
const _6d17786c = () => interopDefault(import('../src/pages/collections/recent.vue' /* webpackChunkName: "pages/collections/recent" */))
const _0bda3738 = () => interopDefault(import('../src/pages/collections/recent/_id/index.vue' /* webpackChunkName: "pages/collections/recent/_id/index" */))
const _297187ad = () => interopDefault(import('../src/pages/deal-catalog.vue' /* webpackChunkName: "pages/deal-catalog" */))
const _10850236 = () => interopDefault(import('../src/pages/deals/index.vue' /* webpackChunkName: "pages/deals/index" */))
const _1c348c93 = () => interopDefault(import('../src/pages/deals/index/_id/index.vue' /* webpackChunkName: "pages/deals/index/_id/index" */))
const _376d2b4c = () => interopDefault(import('../src/pages/deals/index/_id/booking.vue' /* webpackChunkName: "pages/deals/index/_id/booking" */))
const _12c3fd56 = () => interopDefault(import('../src/pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _7df9b001 = () => interopDefault(import('../src/pages/documents/index/_id.vue' /* webpackChunkName: "pages/documents/index/_id" */))
const _0585f674 = () => interopDefault(import('../src/pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _47359dc9 = () => interopDefault(import('../src/pages/fired.vue' /* webpackChunkName: "" */))
const _f2a38920 = () => interopDefault(import('../src/pages/interaction/index.vue' /* webpackChunkName: "pages/interaction/index" */))
const _d2b553d8 = () => interopDefault(import('../src/pages/knowbase/index.vue' /* webpackChunkName: "pages/knowbase/index" */))
const _64720a02 = () => interopDefault(import('../src/pages/legal-documents/index.vue' /* webpackChunkName: "pages/legal-documents/index" */))
const _30c86a47 = () => interopDefault(import('../src/pages/login/index.vue' /* webpackChunkName: "" */))
const _791c4a1b = () => interopDefault(import('../src/pages/loyalty-program/index.vue' /* webpackChunkName: "pages/loyalty-program/index" */))
const _a2e3526a = () => interopDefault(import('../src/pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _979f0072 = () => interopDefault(import('../src/pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _04ddb0ac = () => interopDefault(import('../src/features/survey/ui/QuizSteps' /* webpackChunkName: "features/survey/ui/QuizSteps" */))
const _71dbacca = () => interopDefault(import('../src/pages/quiz.vue' /* webpackChunkName: "" */))
const _1c708f11 = () => interopDefault(import('../src/pages/tekhnoklaster-molzhaninovo-mega/index.vue' /* webpackChunkName: "pages/tekhnoklaster-molzhaninovo-mega/index" */))
const _e8768d3e = () => interopDefault(import('../src/pages/upload-documents.vue' /* webpackChunkName: "" */))
const _0842e011 = () => interopDefault(import('../src/pages/errors/link-expired.vue' /* webpackChunkName: "" */))
const _7e947874 = () => interopDefault(import('../src/pages/print/legal-document.vue' /* webpackChunkName: "pages/print/legal-document" */))
const _209dfe57 = () => interopDefault(import('../src/pages/profile/registration/index.vue' /* webpackChunkName: "" */))
const _4434a4b8 = () => interopDefault(import('../src/pages/profile/fire/select-deals.vue' /* webpackChunkName: "pages/profile/fire/select-deals" */))
const _27eb63ad = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _31745806 = () => interopDefault(import('../src/pages/news/promo/_slug/index.vue' /* webpackChunkName: "pages/news/promo/_slug/index" */))
const _1cdeadca = () => interopDefault(import('../src/pages/print/commercial-offer/_id.vue' /* webpackChunkName: "pages/print/commercial-offer/_id" */))
const _35a0fbbd = () => interopDefault(import('../src/pages/legal-documents/_slug/index.vue' /* webpackChunkName: "pages/legal-documents/_slug/index" */))
const _5d18cdc6 = () => interopDefault(import('../src/pages/news/_slug/index.vue' /* webpackChunkName: "pages/news/_slug/index" */))
const _4cc78fce = () => interopDefault(import('../src/pages/agents/_id/fire/select-deals.vue' /* webpackChunkName: "pages/agents/_id/fire/select-deals" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: '--active-link',
  linkExactActiveClass: '--exact-link',
  scrollBehavior,

  routes: [{
    path: "/account",
    components: {
      default: _05bb4a70,
      aside: _16f85719
    },
    meta: {"hideFooter":true},
    name: "account",
    children: [{
      path: "/account/:role/change-password",
      component: _49ec4b5e,
      meta: {"img":"new_pwd_image","hideFooter":true},
      name: "account-change-password"
    }, {
      path: "/account/:role/email-confirm",
      component: _57a42488,
      meta: {"img":"confirm_send_image","hideFooter":true},
      name: "account-email-confirm"
    }, {
      path: "/account/:role/email-confirmed",
      component: _5bea0da7,
      meta: {"img":"","hideFooter":true},
      name: "account-email-confirmed"
    }, {
      path: "/account/forgot-password",
      component: _41aa0484,
      meta: {"img":"forgot_pwd_image","hideFooter":true},
      name: "account-forgot-password"
    }, {
      path: "/account/forgot-password-emailed",
      component: _fc5155a8,
      meta: {"img":"forgot_pwd_image","hideFooter":true},
      name: "forgot-password-emailed"
    }, {
      path: "/account/:role/reglament",
      component: _2373f160,
      meta: {"img":"accept_contract_image","hideFooter":true},
      name: "account-reglament"
    }, {
      path: "/account/:role/set-password",
      component: _9d74b186,
      meta: {"img":"new_pwd_image","hideFooter":true},
      name: "account-set-password"
    }, {
      path: "/account/agents/registration",
      component: _39f56fdd,
      meta: {"img":"enter_agency_image","hideFooter":true},
      name: "account-registration-agents"
    }, {
      path: "/account/represes/registration",
      component: _02f3c560,
      meta: {"img":"enter_agency_image","hideFooter":true},
      name: "account-registration-represes"
    }, {
      path: "/account/:role/registration/:id?/accepted",
      component: _25bf6844,
      meta: {"img":"enter_personal_image","hideFooter":true},
      name: "account-registration-steps-accepted"
    }, {
      path: "/account/:role/registration/:id?/personal",
      component: _4ab4ddf7,
      meta: {"img":"enter_personal_image","hideFooter":true},
      name: "registration-personal"
    }, {
      path: "/account/:role/registration/:id?/reglament",
      component: _2c343fc0,
      meta: {"img":"accept_contract_image","hideFooter":true},
      name: "account-registration-steps-reglament"
    }, {
      path: "/account/agents/forgot-password",
      component: _41aa0484,
      redirect: "/account/forgot-password",
      meta: {"img":"forgot_pwd_image","hideFooter":true},
      name: "account-forgot-password/account/agents/forgot-password"
    }, {
      path: "/account/represes/forgot-password",
      component: _41aa0484,
      redirect: "/account/forgot-password",
      meta: {"img":"forgot_pwd_image","hideFooter":true},
      name: "account-forgot-password/account/represes/forgot-password"
    }]
  }, {
    path: "/acts",
    component: _42301c99,
    meta: {"disableScrollOnRouteChange":true},
    name: "acts"
  }, {
    path: "/agents",
    component: _f158adf4,
    meta: {"disableScrollOnRouteChange":true},
    name: "agents",
    children: [{
      path: "/agents/:id",
      component: _f327f89e,
      meta: {"disableScrollOnRouteChange":true},
      name: "agents-id"
    }]
  }, {
    path: "/apartment-catalog",
    component: _ac6dfe4e,
    name: "apartment-catalog"
  }, {
    path: "/calendar",
    component: _6b3e3214,
    meta: {"disableScrollOnRouteChange":true},
    name: "calendar",
    children: [{
      path: "/calendar/:type/:id",
      component: _386e6cbe,
      meta: {"disableScrollOnRouteChange":true},
      name: "calendar-id"
    }]
  }, {
    path: "/choice-apartment",
    component: _10232f0a,
    meta: {"disableScrollOnRouteChange":true},
    children: [{
      path: "",
      component: _58293284,
      name: "choice-apartment"
    }, {
      path: "/choice-apartment/catalog",
      component: _3984dd85,
      meta: {"disableScrollOnRouteChange":true},
      name: "choice-apartment-catalog"
    }, {
      path: "/choice-apartment/chessboard",
      component: _71d8b2a6,
      name: "choice-apartment-chessboard"
    }, {
      path: "/choice-apartment/strana-city",
      component: _d617af3e,
      meta: {"disableScrollOnRouteChange":true},
      name: "choice-apartment-catalog-city"
    }, {
      path: "/choice-apartment/chessboard/:project",
      component: _59ef984f,
      meta: {"disableScrollOnRouteChange":true},
      name: "choice-apartment-chessboard-project"
    }, {
      path: "/choice-apartment/:project",
      component: _3df0dac4,
      meta: {"disableScrollOnRouteChange":true},
      name: "choice-apartment-project"
    }]
  }, {
    path: "/clients",
    component: _5fc0d166,
    meta: {"disableScrollOnRouteChange":true},
    name: "clients",
    children: [{
      path: "/clients/:id",
      component: _cd6407de,
      meta: {"disableScrollOnRouteChange":true},
      name: "clients-id"
    }]
  }, {
    path: "/closed-sales",
    component: _c6804040,
    name: "closed-sales"
  }, {
    path: "/collections",
    component: _51c9eea0,
    meta: {"disableScrollOnRouteChange":true},
    name: "collections",
    children: [{
      path: "/collections/create",
      component: _063365eb,
      meta: {"disableScrollOnRouteChange":true},
      name: "collection-create"
    }, {
      path: "/collections/manager",
      component: _3ac78364,
      meta: {"disableScrollOnRouteChange":true},
      name: "collection-manager",
      children: [{
        path: "/collections/manager/:id",
        component: _3cbddcbc,
        meta: {"disableScrollOnRouteChange":true},
        name: "collection-manager-id"
      }]
    }, {
      path: "/collections/recent",
      component: _6d17786c,
      meta: {"disableScrollOnRouteChange":true},
      name: "collection-recent",
      children: [{
        path: "/collections/recent/:id",
        component: _0bda3738,
        meta: {"disableScrollOnRouteChange":true},
        name: "collection-recent-id"
      }]
    }]
  }, {
    path: "/deals/:id/catalog",
    component: _297187ad,
    meta: {"disableScrollOnRouteChange":true},
    name: "deals-id-catalog"
  }, {
    path: "/deals",
    component: _10850236,
    meta: {"disableScrollOnRouteChange":true},
    name: "deals",
    children: [{
      path: "/deals/:id",
      component: _1c348c93,
      meta: {"disableScrollOnRouteChange":true},
      name: "deals-id"
    }, {
      path: "/deals/:id/booking",
      component: _376d2b4c,
      meta: {"disableScrollOnRouteChange":true},
      name: "deals-id-booking"
    }]
  }, {
    path: "/documents",
    component: _12c3fd56,
    meta: {"disableScrollOnRouteChange":true},
    name: "documents",
    children: [{
      path: "/documents/:title/:id",
      component: _7df9b001,
      meta: {"disableScrollOnRouteChange":true},
      name: "documents-id"
    }]
  }, {
    path: "/faq",
    component: _0585f674,
    name: "faq"
  }, {
    path: "/fired",
    components: {
      default: _47359dc9,
      aside: _16f85719
    },
    meta: {"img":"confirm_send_image","hideFooter":true},
    name: "fired"
  }, {
    path: "/interaction",
    component: _f2a38920,
    meta: {"disableScrollOnRouteChange":true},
    name: "interaction"
  }, {
    path: "/knowbase",
    component: _d2b553d8,
    name: "knowbase"
  }, {
    path: "/legal-documents",
    component: _64720a02,
    meta: {"disableScrollOnRouteChange":true},
    name: "legal-documents"
  }, {
    path: "/login",
    components: {
      default: _30c86a47,
      aside: _16f85719
    },
    meta: {"img":"confirm_send_image","hideFooter":true},
    name: "login"
  }, {
    path: "/loyalty-program",
    component: _791c4a1b,
    meta: {"disableScrollOnRouteChange":true},
    name: "loyalty-program"
  }, {
    path: "/news",
    component: _a2e3526a,
    meta: {"disableScrollOnRouteChange":true},
    name: "news"
  }, {
    path: "/profile",
    component: _979f0072,
    meta: {"disableScrollOnRouteChange":true},
    name: "profile"
  }, {
    path: "/deals/:id/quiz",
    components: {
      default: _71dbacca,
      aside: _04ddb0ac,
      mobileMenu: _04ddb0ac
    },
    meta: {"hideFooter":false},
    name: "quiz"
  }, {
    path: "/tekhnoklaster-molzhaninovo-mega",
    component: _1c708f11,
    meta: {"disableScrollOnRouteChange":true},
    name: "tekhnoklaster-molzhaninovo-mega"
  }, {
    path: "/deals/:id/upload-documents",
    components: {
      default: _e8768d3e,
      aside: _04ddb0ac,
      mobileMenu: _04ddb0ac
    },
    meta: {"hideFooter":false},
    name: "upload-documents"
  }, {
    path: "/errors/link-expired",
    components: {
      default: _0842e011,
      aside: _16f85719
    },
    meta: {"img":"forgot_pwd_image","hideFooter":true},
    name: "linkExpired"
  }, {
    path: "/print/legal-document",
    component: _7e947874,
    name: "print-legal-document"
  }, {
    path: "/profile/registration",
    components: {
      default: _209dfe57,
      aside: _16f85719
    },
    meta: {"img":"confirmed_email_image","hideFooter":true},
    name: "profile-registration"
  }, {
    path: "/profile/fire/select-deals",
    component: _4434a4b8,
    meta: {"disableScrollOnRouteChange":true},
    name: "profile-fire-select-deals"
  }, {
    path: "/",
    component: _27eb63ad,
    name: "index"
  }, {
    path: "/news/promo/:slug",
    component: _31745806,
    name: "news-promo-slug"
  }, {
    path: "/print/commercial-offer/:id?",
    component: _1cdeadca,
    name: "print-commercial-offer-id"
  }, {
    path: "/legal-documents/:slug",
    component: _35a0fbbd,
    meta: {"disableScrollOnRouteChange":true},
    name: "legal-documents-slug"
  }, {
    path: "/news/:slug",
    component: _5d18cdc6,
    name: "news-slug"
  }, {
    path: "/agents/:id/fire/select-deals",
    component: _4cc78fce,
    meta: {"disableScrollOnRouteChange":true},
    name: "agents-id-fire"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
